var lists_default = {
  "fontElementMap": "j-oMC",
  "orderedlist": "flVRU",
  "bulletedlist": "_6vbVW",
  "listItem": "_08N7k"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
